<template>
  <div>
    <div class="create-accordian-section">
      <div class="main-contents">
        <ul class="breadcrumbs-list">
          <a href="javascript:void(0)" @click="backButton1"
            ><li>Value Added Services</li></a
          >
          <a href="javascript:void(0)" @click="backButton2"
            ><li>&nbsp;>&nbsp;My WILL</li></a
          >
          <li>&nbsp;>&nbsp;Will Creation</li>
        </ul>
        <h2>WILL Creation for {{will_for_name}}</h2>
        <div class="accodian-box">
          <v-app id="inspire">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header
                  ><p class="head">Part A</p>
                  <div
                    class="sub-header d-flex align-center justify-space-between"
                  >
                    <p>
                      Enter personal details for yourself and your family
                      members
                    </p>
                    <p class="content complete">Completed</p>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div>
                    <v-row class="member-section" >
                      <v-col md="6" sm="6" cols="12" v-for="(item,index) in member_list" :key="item">
                        <div
                          class="member-top-section d-flex align-center justify-space-between"
                         >
                          <p class="member-field">Member {{index+1}}</p>
                          <p class="member-field" style="cursor:pointer" v-if="!seen[index]">
                            <img
                              class="edit-icon"
                              src="../../assets/images/editIcon.png"
                            >
                              Edit
                            
                          </p>
                           <p class="member-field" style="cursor:pointer" v-else-if="seen[index]" v-on:click="saveMemberDetails(index)">
                            <img
                              class="save-icon"
                              src="../../assets/images/save.png"
                            >
                              Save
                            
                          </p>
                          </div>
                          <div class="select-field" v-bind:class="seen[index] ? { disabled: true } : {disabled: false}">
                            <select 
                            v-model="item.name"
                            class="form-select"
                            v-on:click="member_detail(index)"
                            @change="$v.select.$touch()"
                            @blur="$v.select.$touch()"
                            >
                              <option>
                              {{ item.name }}
                            </option>
                            </select>
                        </div>
                    
                        <v-form
                        ref="form"
                        id="member_details"
                        v-if="seen[index]"
                        @submit.prevent
                      >
                      <v-col cols="12" >
                        <div class="row deposits-second-content">
                          <div class="col-sm-6 col-md-6 col-12">
                            <p>NAME</p>
                            <div class="input-field-box">
                              <v-text-field
                               v-model="name"
                                type="text"
                                outlined
                                dense
                                readonly
                              ></v-text-field>
                            </div>
                          </div>
                          
                          <div class="col-sm-6 col-md-6 col-12">
                            <p>GENDER</p>
                            <div class="select-field">
                              <select class="form-select" v-model="gender">
                               <option v-for="option in options" :value="option.value" :key="option">
                                      {{ option.text }}
                              </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-6 col-12 dob-box col">
                            <p>DATE OF BIRTH</p>
                            <div class="input-field-box">
                             <Datepicker
                              v-model="dob"
                              format="dd MMM, yyyy"
                              required
                              @input="ageFinding(index)"
                            ></Datepicker>
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-6 col-12">
                            <p>AGE (in complete years)</p>
                            <div class="input-field-box">
                              <v-text-field
                              v-model="age"
                                type="number"
                                outlined
                                dense
                                readonly
                              ></v-text-field>
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-6 col-12">
                            <p>OCCUPATION</p>
                            <div class="input-field-box">
                              <v-text-field
                                v-model="occupation"
                                type="text"
                                outlined
                                dense
                              ></v-text-field>
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-6 col-12">
                            <p>MARITAL STATUS</p>
                            <div class="select-field">
                              <select class="form-select" v-model="marital_status">
                                <option disabled value="">Please select one</option>
                                <option value="Married">Married</option>
                                <option value="Unmarried">Unmarried</option>
                              </select>
                            </div>
                          </div>
                           <div class="col-md-6 col-12 dob-box col">
                            <p>DATE OF MARRIAGE</p>
                            <div class="input-field-box">
                             <Datepicker
                              v-model="marriage_date"
                              format="dd MMM, yyyy"
                              required
                            ></Datepicker>
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-6 col-12">
                            <p>RELIGION</p>
                            <div class="select-field">
                              <select class="form-select" v-model="religion">
                                <option disabled value="">Please select one</option>
                                <option value="Hindu">Hindu</option>
                                <option value="Muslims">Muslims</option>
                                <option value="Sikhs">Sikhs</option>
                                <option value="Christian">Christian</option>
                              </select>
                            </div>
                          </div>
                           <div class="col-sm-6 col-md-6 col-12">
                            <p>NATIONALITY</p>
                            <div class="input-field-box">
                              <v-text-field
                                v-model="nationality"
                                type="text"
                                outlined
                                dense
                              ></v-text-field>
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-6 col-12">
                            <p>RESIDENTIAL STATUS</p>
                            <div class="input-field-box">
                              <v-text-field
                              v-model="residential_status"
                                type="text"
                                outlined
                                dense
                              ></v-text-field>
                            </div>
                          </div>
                        </div>
                      </v-col>
                      </v-form>
                      </v-col>
                     
                    </v-row>

                    <div class="button-group">
                      <button class="btn cancle-btn">CANCEL</button>
                      <button class="btn save-btn">SAVE</button>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <p class="head">Part B</p>
                  <div
                    class="sub-header d-flex align-center justify-space-between"
                  >
                    <p>How You want to distribute your wealth</p>
                    <p class="content complete">Completed</p>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-app id="sub-accordian">
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <p class="sub-title">Asset Type- Deposits</p>
                           <div class="amount-box">
                          <v-col class="memberbox-editbox">
                        <v-menu bottom left offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              outlined fab
                              color="#F19700"
                              v-bind="attrs"
                              v-on="on"
                              @click="showHide"
                              
                            >
                              <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                            </v-btn>
                          </template>
                          <v-list v-if="hideShow">
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="20"
                                  max-width="20"
                                  :src="edit_pic"
                                  :lazy-src="edit_pic"
                                  ></v-img> Edit
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn>
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" update_pic"
                                  :lazy-src=" update_pic"
                                  > </v-img>Save
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" delete_pic"
                                  :lazy-src=" delete_pic"
                                  > </v-img>Delete
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                         <!-- Deposit COntents -->
                        <v-layout row class="padding">
                                <div
                                    class="mx-auto  pa-2 text-center text-wrap"
                                    max-width="1000"
                                    id="limited-products"
                                  >
                                    <v-data-table
                                      :headers="headers1"
                                      :items="deposit_items"
                                      :hide-default-footer="true"
                                      v-if="!isHidden"
                                    >
                                      <template v-slot:[`item.actions`]="{ item }">
                                        <v-img
                                        max-height="15" max-width="16"
                                        :src="edit_pic"
                                        v-on:click="editItem(item)"
                                        style="cursor:pointer"
                                        ></v-img>
                                      </template>
                                  </v-data-table>
                                  <br/>
                                   <v-data-table
                                      :headers="headers2"
                                      :items="retirement_items"
                                      :hide-default-footer="true"
                                       v-if="!isHidden"
                                    >
                                      <template v-slot:[`item.actions`]="{ item }">
                                        <v-img
                                        max-height="15" max-width="16"
                                        :src="edit_pic"
                                        @click="editItem(item)"
                                        style="cursor:pointer"
                                        ></v-img>
                                      </template>
                                  </v-data-table>
                               </div>
                                </v-layout>
                              <div class="deposits-content" v-if="isHidden">
                            <v-row class="deposits-top-content">
                              <v-col md="6" sm="6" cols="12">
                                <p>DEPOSIT TYPE</p>
                                <div class="select-field">                    
                                  <select class="form-select">
                                    <option selected>
                                      Open this select menu
                                    </option>
                                    
                                  </select>
                                </div>
                              </v-col>
                              <v-col md="6" sm="6" cols="12">
                                <p>ACCOUNT NO.</p>
                                <div class="select-field">                  
                                  <select class="form-select">
                                    <option selected>
                                      Open this select menu
                                    </option>
                                  </select>
                                </div>
                              </v-col>
                              <v-col md="6" sm="6" cols="12">
                                <p>NO. OF NOMINEES TO BEQUEATH</p>
                                <div class="select-field">
                                  <select class="form-select">
                                    <option selected>
                                      Open this select menu
                                    </option>
                                  </select>
                                </div>
                              </v-col>
                            </v-row>
                            <div class="deposits-content2">
                              <v-row class="deposits-second-content">
                                <v-col md="4">
                                  <p>NOMINEE NAME 1</p>
                                  <div class="input-field-box">
                                    <v-text-field
                                      type="text"
                                      outlined
                                      dense
                                      placeholder="Mrs. XXX"
                                    ></v-text-field>
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>RELATONSHIP</p>
                                  <div class="select-field">
                                    <select class="form-select">
                                      <option selected>Wife</option>
                                      <option value="1">Son</option>
                                      <option value="2">Daughter</option>
                                      <option value="3">Father</option>
                                    </select>
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>PERCENTAGE</p>
                                  <div class="select-field">
                                    <select class="form-select">
                                      <option selected>30%</option>
                                      <option value="1">20%</option>
                                      <option value="2">22%</option>
                                      <option value="3">25%</option>
                                    </select>
                                  </div>
                                </v-col>
                              </v-row>
                              <div class="hor-line"></div>

                            </div>
                            <button class="will-button1 saveProceed">
                              SAVE DETAILS
                            </button>
                          </div>
                        
                         
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header
                          ><p class="sub-title">Asset Type- Stocks</p>
                             <div class="amount-box">
                              <v-col class="memberbox-editbox">
                             <v-menu bottom left offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  outlined fab
                                  color="#F19700"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="showHide"
                                  
                                >
                                  <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                                </v-btn>
                              </template>
                              <v-list v-if="hideShow">
                                <v-list-item>
                                  <v-list-item-title>
                                    <v-btn >
                                      <v-img
                                      max-height="20"
                                      max-width="20"
                                      :src="edit_pic"
                                      :lazy-src="edit_pic"
                                      ></v-img> Edit
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-title>
                                    <v-btn>
                                      <v-img
                                      max-height="23"
                                      max-width="19"
                                      :src=" update_pic"
                                      :lazy-src=" update_pic"
                                      > </v-img>Save
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-title>
                                    <v-btn >
                                      <v-img
                                      max-height="23"
                                      max-width="19"
                                      :src=" delete_pic"
                                      :lazy-src=" delete_pic"
                                      > </v-img>Delete
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                        </v-menu>
                      </v-col>
                      </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                         <!-- Stocks Details -->
                          <v-layout row class="padding">
                                <div
                                    class="mx-auto  pa-2 text-center text-wrap"
                                    max-width="1000"
                                    id="limited-products"
                                  >
                                    <v-data-table
                                      :headers="headers3"
                                      :items="stock_items"
                                      :hide-default-footer="true"
                                    >
                                      <template v-slot:[`item.actions`]="{ item }">
                                        <v-img
                                        max-height="15" max-width="16"
                                        :src="edit_pic"
                                        @click="editItem(item)"
                                         style="cursor:pointer"
                                        ></v-img>
                                      </template>
                                  </v-data-table>
                                  </div>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                       <v-expansion-panel>
                        <v-expansion-panel-header
                          ><p class="sub-title">Asset Type- Mutual Funds</p>
                             <div class="amount-box">
                          <v-col class="memberbox-editbox">
                        <v-menu bottom left offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              outlined fab
                              color="#F19700"
                              v-bind="attrs"
                              v-on="on"
                              @click="showHide"
                              
                            >
                              <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                            </v-btn>
                          </template>
                          <v-list v-if="hideShow">
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="20"
                                  max-width="20"
                                  :src="edit_pic"
                                  :lazy-src="edit_pic"
                                  ></v-img> Edit
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn>
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" update_pic"
                                  :lazy-src=" update_pic"
                                  > </v-img>Save
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" delete_pic"
                                  :lazy-src=" delete_pic"
                                  > </v-img>Delete
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                         <!-- Mutual  Details -->
                          <v-layout row class="padding">
                                <div
                                    class="mx-auto  pa-2 text-center text-wrap"
                                    max-width="1000"
                                    id="limited-products"
                                  >
                                    <v-data-table
                                      :headers="headers4"
                                      :items="mutual_fund_items"
                                      :hide-default-footer="true"
                                    >
                                     <template v-slot:[`item.actions`]="{ item }">
                                        <v-img
                                        max-height="15" max-width="16"
                                        :src="edit_pic"
                                        @click="editItem(item)"
                                         style="cursor:pointer"
                                        ></v-img>
                                    </template>
                                  </v-data-table>
                                  </div>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                       <v-expansion-panel>
                        <v-expansion-panel-header
                          ><p class="sub-title">Asset Type- Bullion</p>
                            <div class="amount-box">
                          <v-col class="memberbox-editbox">
                        <v-menu bottom left offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              outlined fab
                              color="#F19700"
                              v-bind="attrs"
                              v-on="on"
                              @click="showHide"
                              
                            >
                              <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                            </v-btn>
                          </template>
                          <v-list v-if="hideShow">
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="20"
                                  max-width="20"
                                  :src="edit_pic"
                                  :lazy-src="edit_pic"
                                  ></v-img> Edit
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn>
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" update_pic"
                                  :lazy-src=" update_pic"
                                  > </v-img>Save
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" delete_pic"
                                  :lazy-src=" delete_pic"
                                  > </v-img>Delete
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                         <!-- Bullion Details -->
                          <v-layout row class="padding">
                                <div
                                    class="mx-auto  pa-2 text-center text-wrap"
                                    max-width="1000"
                                    id="limited-products"
                                  >
                                    <v-data-table
                                      :headers="headers5"
                                      :items="bullion_items"
                                      :hide-default-footer="true"
                                    >
                                     <template v-slot:[`item.actions`]="{ item }">
                                         <v-img
                                        max-height="15" max-width="16"
                                        :src="edit_pic"
                                        @click="editItem(item)"
                                         style="cursor:pointer"
                                        ></v-img>
                                     </template>
                                  </v-data-table>
                                  </div>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                       <v-expansion-panel>
                        <v-expansion-panel-header
                          ><p class="sub-title">Asset Type- Bonds</p>
                          <div class="amount-box">
                          <v-col class="memberbox-editbox">
                        <v-menu bottom left offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              outlined fab
                              color="#F19700"
                              v-bind="attrs"
                              v-on="on"
                              @click="showHide"
                              
                            >
                              <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                            </v-btn>
                          </template>
                          <v-list v-if="hideShow">
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="20"
                                  max-width="20"
                                  :src="edit_pic"
                                  :lazy-src="edit_pic"
                                  ></v-img> Edit
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn>
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" update_pic"
                                  :lazy-src=" update_pic"
                                  > </v-img>Save
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" delete_pic"
                                  :lazy-src=" delete_pic"
                                  > </v-img>Delete
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                         <!-- Bonds Details -->
                          <v-layout row class="padding">
                                <div
                                    class="mx-auto  pa-2 text-center text-wrap"
                                    max-width="1000"
                                    id="limited-products"
                                  >
                                    <v-data-table
                                      :headers="headers6"
                                      :items="bonds_items"
                                      :hide-default-footer="true"
                                    >
                                     <template v-slot:[`item.actions`]="{ item }">
                                        <v-img
                                        max-height="15" max-width="16"
                                        :src="edit_pic"
                                        @click="editItem(item)"
                                         style="cursor:pointer"
                                        ></v-img>
                                    </template>
                                  </v-data-table>
                                  </div>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                       <v-expansion-panel>
                        <v-expansion-panel-header
                          ><p class="sub-title">Asset Type- Real Estate</p>
                            <div class="amount-box">
                          <v-col class="memberbox-editbox">
                        <v-menu bottom left offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              outlined fab
                              color="#F19700"
                              v-bind="attrs"
                              v-on="on"
                              @click="showHide"
                              
                            >
                              <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                            </v-btn>
                          </template>
                          <v-list v-if="hideShow">
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="20"
                                  max-width="20"
                                  :src="edit_pic"
                                  :lazy-src="edit_pic"
                                  ></v-img> Edit
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn>
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" update_pic"
                                  :lazy-src=" update_pic"
                                  > </v-img>Save
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" delete_pic"
                                  :lazy-src=" delete_pic"
                                  > </v-img>Delete
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      </div>
                    </v-expansion-panel-header>
                      <v-expansion-panel-content>
                         <!-- Real Estate Details -->
                          <v-layout row class="padding">
                                <div
                                    class="mx-auto  pa-2 text-center text-wrap"
                                    max-width="1000"
                                    id="limited-products"
                                  >
                                    <v-data-table
                                      :headers="headers7"
                                      :items="realestate_items"
                                      :hide-default-footer="true"
                                    >
                                     <template v-slot:[`item.actions`]="{ item }">
                                        <v-img
                                        max-height="15" max-width="16"
                                        :src="edit_pic"
                                        @click="editItem(item)"
                                         style="cursor:pointer"
                                        ></v-img>
                                    </template>
                                  </v-data-table>
                                  </div>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                       <v-expansion-panel>
                        <v-expansion-panel-header
                          ><p class="sub-title">Asset Type- Private Investment</p>
                            <div class="amount-box">
                          <v-col class="memberbox-editbox">
                        <v-menu bottom left offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              outlined fab
                              color="#F19700"
                              v-bind="attrs"
                              v-on="on"
                              @click="showHide"
                              
                            >
                              <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                            </v-btn>
                          </template>
                          <v-list v-if="hideShow">
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="20"
                                  max-width="20"
                                  :src="edit_pic"
                                  :lazy-src="edit_pic"
                                  ></v-img> Edit
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn>
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" update_pic"
                                  :lazy-src=" update_pic"
                                  > </v-img>Save
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" delete_pic"
                                  :lazy-src=" delete_pic"
                                  > </v-img>Delete
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                     </div>
                    </v-expansion-panel-header>
                        <v-expansion-panel-content>
                         <!-- Private Investment Details -->
                          <v-layout row class="padding">
                                <div
                                    class="mx-auto  pa-2 text-center text-wrap"
                                    max-width="1000"
                                    id="limited-products"
                                  >
                                    <v-data-table
                                      :headers="headers8"
                                      :items="private_investment_items"
                                      :hide-default-footer="true"
                                    >
                                     <template v-slot:[`item.actions`]="{ item }">
                                       <v-img
                                        max-height="15" max-width="16"
                                        :src="edit_pic"
                                        @click="editItem(item)"
                                         style="cursor:pointer"
                                        ></v-img>
                                    </template>
                                  </v-data-table>
                                  </div>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      
                    </v-expansion-panels>
                     <div class="button-group">
                      <button class="btn cancle-btn">CANCEL</button>
                      <button class="btn save-btn" >SAVE</button>
                    </div>
                  </v-app>
                  
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <p class="head">Part C</p>
                  <div
                    class="sub-header d-flex align-center justify-space-between"
                  >
                    <p>Fill Your Witnesses Details</p>
                    <p class="content pending">Pending</p>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-app id="sub-accordian">
                    <v-expansion-panels>
                      <v-expansion-panel class="deposits-section">
                        <v-expansion-panel-header
                          ><p class="sub-title">Witness 1</p>
                         <div class="amount-box">
                          <v-col class="memberbox-editbox">
                          <v-menu bottom left offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                outlined fab
                                color="#F19700"
                                v-bind="attrs"
                                v-on="on"
                                @click="showHide"
                                
                              >
                              <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                            </v-btn>
                          </template>
                          <v-list v-if="hideShow">
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="20"
                                  max-width="20"
                                  :src="edit_pic"
                                  :lazy-src="edit_pic"
                                  ></v-img> Edit
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn>
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" update_pic"
                                  :lazy-src=" update_pic"
                                  > </v-img>Save
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" delete_pic"
                                  :lazy-src=" delete_pic"
                                  > </v-img>Delete
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      </div>
                    </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <div class="hr-line"></div>
                          <div class="deposits-content">
                            <v-row class="deposits-second-content">
                              <v-col md="4" sm="6" cols="12">
                                <p>NAME</p>
                                <div class="input-field-box">
                                  <v-text-field
                                    type="text"
                                    v-model="w_name"
                                    outlined
                                    dense
                                    placeholder="Mrs. XXX"
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>CONTACT NUMBER</p>
                                <div class="input-field-box">
                                  <v-text-field
                                    type="text"
                                    v-model="w_number"
                                    outlined
                                    dense
                                    placeholder="9999999999"
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>RELATION</p>
                                <div class="input-field-box">
                                   <v-text-field
                                    type="text"
                                    v-model="w_relation"
                                    outlined
                                    dense
                                    placeholder="SON"
                                  ></v-text-field>
                                </div>
                              </v-col>
                                <v-col md="4" sm="6" cols="12">
                                <p>OCCUPATION</p>
                                <div class="input-field-box">
                                   <v-text-field
                                    type="text"
                                    v-model="w_occupation"
                                    outlined
                                    dense
                                    placeholder="Business"
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>ADDRESS 1</p>
                                <div class="input-field-box">
                                  <v-text-field
                                    type="text"
                                    v-model="w_add"
                                    outlined
                                    dense
                                    placeholder="1/6, Red Rose Apartments"
                                  ></v-text-field>
                                </div>
                              </v-col>
                               <v-col md="4" sm="6" cols="12">
                                <p>ADDRESS 2</p>
                                <div class="input-field-box">
                                  <v-text-field
                                    type="text"
                                    v-model="w_add2"
                                    outlined
                                    dense
                                    placeholder="1/6, Red Rose Apartments"
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>STATE</p>
                                <div class="input-field-box">
                                   <v-text-field
                                    type="text"
                                    v-model="w_state"
                                    outlined
                                    dense
                                    placeholder="U.P."
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>CITY</p>
                                <div class="input-field-box">
                                  <v-text-field
                                    type="text"
                                    v-model="w_city"
                                    outlined
                                    dense
                                    placeholder="Gorakhpur"
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>PIN</p>
                                <div class="input-field-box">
                                   <v-text-field
                                    type="text"
                                    v-model="w_pin"
                                    outlined
                                    dense
                                    placeholder="273015"
                                  ></v-text-field>
                                </div>
                              </v-col>
                            </v-row>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel class="deposits-section">
                        <v-expansion-panel-header
                          ><p class="sub-title">Witness 2</p>
                         <div class="amount-box">
                          <v-col class="memberbox-editbox">
                          <v-menu bottom left offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                outlined fab
                                color="#F19700"
                                v-bind="attrs"
                                v-on="on"
                                @click="showHide"
                                
                              >
                              <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                            </v-btn>
                          </template>
                          <v-list v-if="hideShow">
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="20"
                                  max-width="20"
                                  :src="edit_pic"
                                  :lazy-src="edit_pic"
                                  ></v-img> Edit
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn>
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" update_pic"
                                  :lazy-src=" update_pic"
                                  > </v-img>Save
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" delete_pic"
                                  :lazy-src=" delete_pic"
                                  > </v-img>Delete
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div class="hr-line"></div>
                          <!-- <div class="deposits-content">
                            <v-row class="deposits-top-content">
                              <v-col md="4" sm="6" cols="12">
                                <p>DEPOSIT TYPE</p>
                                <div class="select-field">
                                  <div class="select-profile-name">SW</div>
                                  <select class="form-select">
                                    <option selected>
                                      Open this select menu
                                    </option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                  </select>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>ACCOUNT NO.</p>
                                <div class="select-field">
                                  <div class="select-profile-name">SW</div>
                                  <select class="form-select">
                                    <option selected>
                                      Open this select menu
                                    </option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                  </select>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>NO. OF NOMINEES TO BEQUEATH</p>
                                <div class="select-field">
                                  <div class="select-profile-name">SW</div>
                                  <select class="form-select">
                                    <option selected>
                                      Open this select menu
                                    </option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                  </select>
                                </div>
                              </v-col>
                            </v-row>
                            <div class="deposits-content2">
                              <v-row class="deposits-second-content">
                                <v-col md="4">
                                  <p>NOMINEE NAME 1</p>
                                  <div class="input-field-box">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="Mrs. XXX"
                                    />
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>RELATONSHIP</p>
                                  <div class="select-field">
                                    <div class="select-profile-name">SW</div>
                                    <select class="form-select">
                                      <option selected>Wife</option>
                                      <option value="1">Son</option>
                                      <option value="2">Daughter</option>
                                      <option value="3">Father</option>
                                    </select>
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>PERCENTAGE</p>
                                  <div class="select-field">
                                    <div class="select-profile-name">SW</div>
                                    <select class="form-select">
                                      <option selected>30%</option>
                                      <option value="1">20%</option>
                                      <option value="2">22%</option>
                                      <option value="3">25%</option>
                                    </select>
                                  </div>
                                </v-col>
                              </v-row>
                              <div class="hor-line"></div>

                              <v-row class="deposits-second-content">
                                <v-col md="4" sm="6" cols="12">
                                  <p>NOMINEE NAME 1</p>
                                  <div class="input-field-box">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="Mrs. XXX"
                                    />
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>RELATONSHIP</p>
                                  <div class="select-field">
                                    <div class="select-profile-name">SW</div>
                                    <select class="form-select">
                                      <option selected>Son</option>
                                      <option value="1">wife</option>
                                      <option value="2">Daughter</option>
                                      <option value="3">Father</option>
                                    </select>
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>PERCENTAGE</p>
                                  <div class="select-field">
                                    <div class="select-profile-name">SW</div>
                                    <select class="form-select">
                                      <option selected>25%</option>
                                      <option value="1">20%</option>
                                      <option value="2">22%</option>
                                      <option value="3">27%</option>
                                    </select>
                                  </div>
                                </v-col>
                              </v-row>
                              <div class="hor-line"></div>
                              <v-row class="deposits-second-content">
                                <v-col md="4" sm="6" cols="12">
                                  <p>NOMINEE NAME 2</p>
                                  <div class="input-field-box">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="Mrs. XXX"
                                    />
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>RELATONSHIP</p>
                                  <div class="select-field">
                                    <div class="select-profile-name">SW</div>
                                    <select class="form-select">
                                      <option selected>Wife</option>
                                      <option value="1">One</option>
                                      <option value="2">Two</option>
                                      <option value="3">Three</option>
                                    </select>
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>PERCENTAGE</p>
                                  <div class="select-field">
                                    <div class="select-profile-name">SW</div>
                                    <select class="form-select">
                                      <option selected>20%</option>
                                      <option value="1">23%</option>
                                      <option value="2">25%</option>
                                      <option value="3">27%</option>
                                    </select>
                                  </div>
                                </v-col>
                              </v-row>
                            </div>
                            <button class="will-button1 saveProceed">
                              SAVE DETAILS
                            </button>
                          </div> -->
                        <div class="deposits-content">
                            <v-row class="deposits-second-content">
                              <v-col md="4" sm="6" cols="12">
                                <p>NAME</p>
                                <div class="input-field-box">
                                  <v-text-field
                                    type="text"
                                    outlined
                                    dense
                                    placeholder="Mrs. XXX"
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>CONTACT NUMBER</p>
                                <div class="input-field-box">
                                  <v-text-field
                                    type="text"
                                    outlined
                                    dense
                                    placeholder="9999999999"
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>RELATION</p>
                                <div class="input-field-box">
                                   <v-text-field
                                    type="text"
                                    outlined
                                    dense
                                    placeholder="SON"
                                  ></v-text-field>
                                </div>
                              </v-col>
                                <v-col md="4" sm="6" cols="12">
                                <p>OCCUPATION</p>
                                <div class="input-field-box">
                                   <v-text-field
                                    type="text"
                                    outlined
                                    dense
                                    placeholder="Business"
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>ADDRESS 1</p>
                                <div class="input-field-box">
                                  <v-text-field
                                    type="text"
                                    outlined
                                    dense
                                    placeholder="1/6, Red Rose Apartments"
                                  ></v-text-field>
                                </div>
                              </v-col>
                               <v-col md="4" sm="6" cols="12">
                                <p>ADDRESS 2</p>
                                <div class="input-field-box">
                                  <v-text-field
                                    type="text"
                                    outlined
                                    dense
                                    placeholder="1/6, Red Rose Apartments"
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>STATE</p>
                                <div class="input-field-box">
                                   <v-text-field
                                    type="text"
                                    outlined
                                    dense
                                    placeholder="U.P."
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>CITY</p>
                                <div class="input-field-box">
                                  <v-text-field
                                    type="text"
                                    outlined
                                    dense
                                    placeholder="Gorakhpur"
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>PIN</p>
                                <div class="input-field-box">
                                   <v-text-field
                                    type="text"
                                    outlined
                                    dense
                                    placeholder="273015"
                                  ></v-text-field>
                                </div>
                              </v-col>
                            </v-row>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <div class="button-group">
                      <button class="btn cancle-btn">CANCEL</button>
                      <button class="btn save-btn">SAVE</button>
                    </div>
                  </v-app>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <p class="head">Part D</p>
                  <div
                    class="sub-header d-flex align-center justify-space-between"
                  >
                    <p>Fill Your Executors Details</p>
                    <p class="content pending">Pending</p>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-app id="sub-accordian">
                    <v-expansion-panels>
                      <v-expansion-panel class="deposits-section">
                        <v-expansion-panel-header
                          ><p class="sub-title">Executor 1</p>
                          <div class="amount-box">
                          <v-col class="memberbox-editbox">
                          <v-menu bottom left offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                outlined fab
                                color="#F19700"
                                v-bind="attrs"
                                v-on="on"
                                @click="showHide"
                                
                              >
                              <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                            </v-btn>
                          </template>
                          <v-list v-if="hideShow">
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="20"
                                  max-width="20"
                                  :src="edit_pic"
                                  :lazy-src="edit_pic"
                                  ></v-img> Edit
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn>
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" update_pic"
                                  :lazy-src=" update_pic"
                                  > </v-img>Save
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" delete_pic"
                                  :lazy-src=" delete_pic"
                                  > </v-img>Delete
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      </div>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <div class="hr-line"></div>
                          <div class="deposits-content">
                            <v-row class="deposits-second-content">
                              <v-col md="4" sm="6" cols="12">
                                <p>NAME</p>
                                <div class="input-field-box">
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Mrs. XXX"
                                  />
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>CONTACT NUMBER</p>
                                <div class="input-field-box">
                                  <input
                                    type="number"
                                    class="form-control"
                                    placeholder="9876644321"
                                  />
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>SON/DAUGHTER OF</p>
                                <div class="input-field-box">
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Vivek Sharma"
                                  />
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>ADDRESS 1</p>
                                <div class="input-field-box">
                                  <input
                                    type="number"
                                    class="form-control"
                                    placeholder="1/6, Red Rose Apartments"
                                  />
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>STATE</p>
                                <div class="input-field-box">
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Rishab Sharma"
                                  />
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>CITY</p>
                                <div class="input-field-box">
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder="9876644321"
                                  />
                                </div>
                              </v-col>
                              <v-col md="4" sm="6" cols="12">
                                <p>PIN</p>
                                <div class="input-field-box">
                                  <input
                                    type="number"
                                    class="form-control"
                                    placeholder="Rishab Sharma"
                                  />
                                </div>
                              </v-col>
                            </v-row>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel class="deposits-section">
                        <v-expansion-panel-header
                          ><p class="sub-title">Executor 2</p>
                           <div class="amount-box">
                          <v-col class="memberbox-editbox">
                          <v-menu bottom left offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                outlined fab
                                color="#F19700"
                                v-bind="attrs"
                                v-on="on"
                                @click="showHide"
                                
                              >
                              <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                            </v-btn>
                          </template>
                          <v-list v-if="hideShow">
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="20"
                                  max-width="20"
                                  :src="edit_pic"
                                  :lazy-src="edit_pic"
                                  ></v-img> Edit
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn>
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" update_pic"
                                  :lazy-src=" update_pic"
                                  > </v-img>Save
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                <v-btn >
                                  <v-img
                                  max-height="23"
                                  max-width="19"
                                  :src=" delete_pic"
                                  :lazy-src=" delete_pic"
                                  > </v-img>Delete
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div class="hr-line"></div>
                          <div class="deposits-content">
                            <v-row class="deposits-top-content">
                              <v-col md="6" sm="6" cols="12">
                                <p>DEPOSIT TYPE</p>
                                <div class="select-field">                    
                                  <select class="form-select">
                                    <option selected>
                                      Open this select menu
                                    </option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                  </select>
                                </div>
                              </v-col>
                              <v-col md="6" sm="6" cols="12">
                                <p>ACCOUNT NO.</p>
                                <div class="select-field">                  
                                  <select class="form-select">
                                    <option selected>
                                      Open this select menu
                                    </option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                  </select>
                                </div>
                              </v-col>
                              <v-col md="6" sm="6" cols="12">
                                <p>NO. OF NOMINEES TO BEQUEATH</p>
                                <div class="select-field">
                                  <select class="form-select">
                                    <option selected>
                                      Open this select menu
                                    </option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                  </select>
                                </div>
                              </v-col>
                            </v-row>
                            <div class="deposits-content2">
                              <v-row class="deposits-second-content">
                                <v-col md="4">
                                  <p>NOMINEE NAME 1</p>
                                  <div class="input-field-box">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="Mrs. XXX"
                                    />
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>RELATONSHIP</p>
                                  <div class="select-field">
                                    <div class="select-profile-name">SW</div>
                                    <select class="form-select">
                                      <option selected>Wife</option>
                                      <option value="1">Son</option>
                                      <option value="2">Daughter</option>
                                      <option value="3">Father</option>
                                    </select>
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>PERCENTAGE</p>
                                  <div class="select-field">
                                    <div class="select-profile-name">SW</div>
                                    <select class="form-select">
                                      <option selected>30%</option>
                                      <option value="1">20%</option>
                                      <option value="2">22%</option>
                                      <option value="3">25%</option>
                                    </select>
                                  </div>
                                </v-col>
                              </v-row>
                              <div class="hor-line"></div>

                              <v-row class="deposits-second-content">
                                <v-col md="4" sm="6" cols="12">
                                  <p>NOMINEE NAME 1</p>
                                  <div class="input-field-box">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="Mrs. XXX"
                                    />
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>RELATONSHIP</p>
                                  <div class="select-field">
                                   
                                    <select class="form-select">
                                      <option selected>Son</option>
                                      <option value="1">wife</option>
                                      <option value="2">Daughter</option>
                                      <option value="3">Father</option>
                                    </select>
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>PERCENTAGE</p>
                                  <div class="select-field">
                                    
                                    <select class="form-select">
                                      <option selected>25%</option>
                                      <option value="1">20%</option>
                                      <option value="2">22%</option>
                                      <option value="3">27%</option>
                                    </select>
                                  </div>
                                </v-col>
                              </v-row>
                              <div class="hor-line"></div>
                              <v-row class="deposits-second-content">
                                <v-col md="4" sm="6" cols="12">
                                  <p>NOMINEE NAME 2</p>
                                  <div class="input-field-box">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="Mrs. XXX"
                                    />
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>RELATONSHIP</p>
                                  <div class="select-field">
                                    <div class="select-profile-name">SW</div>
                                    <select class="form-select">
                                      <option selected>Wife</option>
                                      <option value="1">One</option>
                                      <option value="2">Two</option>
                                      <option value="3">Three</option>
                                    </select>
                                  </div>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <p>PERCENTAGE</p>
                                  <div class="select-field">
                                    <div class="select-profile-name">SW</div>
                                    <select class="form-select">
                                      <option selected>20%</option>
                                      <option value="1">23%</option>
                                      <option value="2">25%</option>
                                      <option value="3">27%</option>
                                    </select>
                                  </div>
                                </v-col>
                              </v-row>
                            </div>
                            <button class="will-button1 saveProceed">
                              SAVE DETAILS
                            </button>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <div class="button-group">
                      <button class="btn cancle-btn">CANCEL</button>
                      <button class="btn save-btn">SAVE</button>
                    </div>
                  </v-app>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-app>
          <div class="text-center">
            <button
              class="will-button1 saveProceed"
              @click="procced_dialog = true"
            >
              SAVE AND PROCEED
            </button>
          </div>
        </div>
      </div>
    </div>
    <v-dialog
      content-class="modal-style"
      v-model="procced_dialog"
      persistent
      height="800px"
      max-width="892px"
    >
      <v-card>
        <div class="header-section d-flex justify-content-between">
          <h2 class="header">
            MY<sub style="color: #f19700; font-size: 18px"> WILL</sub>
          </h2>
          <span class="cross-icon">
            <v-img
              @click="procced_dialog = false"
              :src="require('@/assets/images/cross.png')"
            >
            </v-img>
          </span>
        </div>
        <h3 class="sub-head">Generate Your WILL</h3>
        <div class="dialog-para">
          <p>
            Now that you have provided all your information you can either
            “Save” the data or click to “Preview” and “Confirm” your WILL.
          </p>
          <p>
            If you choose “Save” option your information will be saved and you
            will have 15 days to make any changes and proceed towards WILL
            creation. Post 15 days you will have the option to “Preview” and
            “Confirm” your WILL. “Preview” option will help you to make
            necessary changes in the document before you “Confirm”. Once you
            “Confirm”, your WILL be generated in a PDF format. You can download
            the same. Please sign every page of the document and get it attested
            by the two witnesses specified.
          </p>
          <p>
            You can notarize or register your WILL document. Nimeya in
            association with “ABC Ltd” will assist you in notarization or
            registration of your WILL. Do select the appropriate option at the
            time of generating PDF report.
          </p>
          <p>
            Please note noratization or registration of WILL is not a mandatory
            requirement as per law however, we would recommend the same to avoid
            any litigation at a future date.
          </p>
        </div>
        <!-- <div class="will_button-container">
              <button class="will-button1" @click="stepCreateWill()">PROCEED</button>
      </div> -->
        <div class="button-group">
          <button class="btn save-btn" @click="details()">SAVE</button>
          <button class="btn cancle-btn">PREVIEW</button>
          <button class="btn cancle-btn" @click="procced_dialog = false">
            CANCEL
          </button>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import axios from 'axios';
import { Auth } from "aws-amplify";
import moment from 'moment'
export default {
   components: {
        Datepicker,
    },
  data: () => ({
    three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
        edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
        delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
        update_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'update.png',
        hideShow:false,
        hideShowId:'',
        allow_user_activity:localStorage.getItem('allow_user_activity'),
    procced_dialog: false,
    member_list: [],
    seen: [],
    item:[],
    memberDetails: [],
    age:'',
    gender:[],
    dob:'',
    id:'',
    occupation:'',
    member: [],
    religion:'',
    marital_status:'',
    marriage_date:'',
    nationality:'',
    residential_status:'',
    selectedMembers: [],
    select: null,
    name:'',
    deposit_items:[],
    items:[],
     options: [
        { text: 'MALE', value: 'MALE' },
        { text: 'FEMALE', value: 'FEMALE' },
        { text: 'OTHER', value: 'OTHERS' }
      ],
   
     headers1: [

       { text: "Deposit Type", align: "start",sortable: false,value: "form_name",},
       { text: "Account No.", align: "start",sortable: false,value: "account_no",},
       { text: "No. of Nominee to Bequeath",align: "start",sortable: false,value: "nominee.length",},
       { text: "Nominees Names", align: "start",sortable: false,value: "nominee",},
       { text: "% Share to Bequeath", align: "start",sortable: false,value: "",},
       { text: "Relationship with You", align: "start",sortable: false,value: "", },
       { text: "Actions", value: "actions", sortable: false },
    ],
     headers2: [
      { text: "Scheme Type", align: "start",sortable: false,value: "form_name"},
      { text: "Account No.", align: "start",sortable: false,value: "account_no"},
      { text: "No. of Nominee to Bequeath",align: "start",sortable: false,value: "nominee.length"},
      { text: "Nominees Names", align: "start",sortable: false,value: "nominee"},
      { text: "% Share to Bequeath", align: "start",sortable: false,value: ""},
      { text: "Relationship with You", align: "start",sortable: false,value: ""},
      { text: "Actions", value: "actions", sortable: false },
    ],
     headers3: [
      { text: "Stock Type", align: "start",sortable: false,value: "form_name"},
      { text: "Stock Name", align: "start",sortable: false,value: "bank_name"},
      { text: "No. of Nominee to Bequeath",align: "start",sortable: false,value: "nominee.length"},
      { text: "Member Names", align: "start",sortable: false,value: "nominee"},
      { text: "% Share to Bequeath", align: "start",sortable: false,value: ""},
      { text: "Relationship with You", align: "start",sortable: false,value: ""},
      { text: "Actions", value: "actions", sortable: false},
    ],
     headers4: [
      { text: "Fund Name", align: "start",sortable: false,value: "scheme_type"},
      { text: "Folio No.", align: "start",sortable: false,value: "folio_no"},
      { text: "No. of Nominee to Bequeath",align: "start",sortable: false,value: "nominee.length"},
      { text: "Member Names", align: "start",sortable: false,value: "nominee"},
      { text: "% Share to Bequeath", align: "start",sortable: false,value: ""},
      { text: "Relationship with You", align: "start",sortable: false,value: ""},
      { text: "Actions", value: "actions", sortable: false },
    ],
     headers5: [
      { text: "Bullion Type", align: "start",sortable: false,value: "form_name"},
      { text: "Quantity(in gms)", align: "start",sortable: false,value: "quantity",},
      { text: "No. of Nominee to Bequeath",align: "start",sortable: false,value: "nominee.length"},
      { text: "Member Names", align: "start",sortable: false,value: "nominee"},
      { text: "% Share to Bequeath", align: "start",sortable: false,value: ""},
      { text: "Relationship with You", align: "start",sortable: false,value: ""},
      { text: "Actions", value: "actions", sortable: false},
    ],
     headers6: [
      { text: "Bond Name", align: "start",sortable: false,value: "bond"},
      { text: "Units", align: "start",sortable: false,value: "quantity"},
      { text: "No. of Nominee to Bequeath",align: "start",sortable: false,value: "nominee.length"},
      { text: "Member Names", align: "start",sortable: false,value: "nominee"},
      { text: "% Share to Bequeath", align: "start",sortable: false,value: ""},
      { text: "Relationship with You", align: "start",sortable: false,value: ""},
      { text: "Actions", value: "actions", sortable: false},
    ],
     headers7: [
      { text: "Real Estate Type", align: "start",sortable: false,value: "property_type"},
      { text: "Name & Address", align: "start",sortable: false,value: "state"},
      { text: "No. of Nominee to Bequeath",align: "start",sortable: false,value: "nominee.length"},
      { text: "Member Names", align: "start",sortable: false,value: "nominee"},
      { text: "% Share to Bequeath", align: "start",sortable: false,value: ""},
      { text: "Relationship with You", align: "start",sortable: false,value: ""},
      { text: "Actions", value: "actions", sortable: false},
    ],
     headers8: [
      { text: "Investment Type", align: "start",sortable: false,value: "form_name"},
      { text: "Company/Fund Name", align: "start",sortable: false,value: "pms_name"},
      { text: "No. of Nominee to Bequeath",align: "start",sortable: false,value: "nominee.length"},
      { text: "Member Names", align: "start",sortable: false,value: "nominees"},
      { text: "% Share to Bequeath", align: "start",sortable: false,value: ""},
      { text: "Relationship with You", align: "start",sortable: false,value: ""},
      { text: "Actions", value: "actions", sortable: false},
    ],
    items: [],
    responses:[],
    retirement_items:[],
    stock_items:[],
    mutual_fund_items:[],
    bullion_items:[],
    bonds_items:[],
    realestate_items:[],
    private_investment_items:[],
    isHidden: false,
  }),
   
  mounted() {
    this.initialize();
   
    this.depositDetails();
    this.ageFinding(index);
  },
  methods: {
     showHide(){
      this.hideShow =true;
      },
     

    initialize() {
       Auth.currentAuthenticatedUser({
					bypassCache: false
				}).then(user => {	
					this.user_name = user.attributes["custom:name"];
					let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
					let formdata  = new FormData();
					formdata.append("aws_cognito_id", cognito_idp);
					formdata.append("user_name", user.attributes["custom:name"]);
            axios.post(process.env.VUE_APP_ROOT_API + "selected-member-list", formdata).then((response) => {
              this.member_list = response.data.data.will_member_details;
              this.will_for_name = response.data.data.name;
              // console.log(this.member_list);
              this.member_list.forEach(element => {
                this.seen.push(false)
              });
					})
        })
    },
    member_detail(index){
        // this.seen[index]=true;
        this.$set(this.seen, index, !this.seen[index]);
        this.name =this.member_list[index].name;
        this.id =this.member_list[index].id;
        this.gender = this.member_list[index].gender;
        this.dob = this.member_list[index].dob;
         let dob1 = moment(String(this.dob)).format('DD MMM, yyyy')
         let DOB = new Date(dob1);
         console.log('FFF',DOB);
         let today = new Date();
        this.member_list[index].age = today.getFullYear() - DOB.getFullYear();
        this.age =this.member_list[index].age;
        this.occupation = this.member_list[index].occupation;
        this.marital_status = this.member_list[index].marital_status;
        this.religion = this.member_list[index].religion;
        this.residential_status = this.member_list[index].residential_status;
        this.marriage_date = this.member_list[index].marriage_date;
        this.nationality = this.member_list[index].nationality;
    },
    saveMemberDetails(index){
        // this.$loading(true);
        this.dob = moment(String(this.dob)).format('DD MMM, yyyy')
        this.marriage_date = moment(String(this.marriage_date)).format('DD MMM, yyyy')
      	let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
        let getFormData = document.querySelector('#member_details');
        var formdata = new FormData(getFormData)
        formdata.append("aws_cognito_id", cognito_idp);
        formdata.append("name", this.name);
        formdata.append("member_id", this.id);
        formdata.append("age", this.age);
        formdata.append("gender", this.gender);
        formdata.append("dob", this.dob );
        formdata.append("occupation", this.occupation);
        formdata.append("marital_status", this.marital_status);
        formdata.append("religion", this.religion);
        formdata.append("residential_status", this.residential_status);
        formdata.append("marriage_date", this.marriage_date);
        formdata.append("nationality", this.nationality);
        axios.post(process.env.VUE_APP_ROOT_API + "save-member-details", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        }).then((response) => {
          // console.log(response);
          if(response.data.status == 'success')
          {
            // this.$loading(false);
            this.$set(this.seen, index, !this.seen[index]);
            swal.fire({
              title:'Member added successfully',
              icon:'success'
            })
          
          }
        })
    },
    ageFinding(index){
      this.dob = moment(String(this.dob)).format('DD MMM, yyyy')
         let DOB = new Date(this.dob);
          console.log('DOB',DOB);
         let today = new Date();
         console.log('today',today);
        this.member_list[index].age = today.getFullYear() - DOB.getFullYear();
        
        this.age = this.member_list[index].age;
    },
    depositDetails(){
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          let formdata  = new FormData();
					formdata.append("aws_cognito_id", cognito_idp);
          formdata.append("user_name", Auth.currentAuthenticatedUser());
          axios
            .post(process.env.VUE_APP_ROOT_API + "get-deposit-details",formdata, {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "*",
              },
            })
            .then((response) => {
            this.deposit_items = response.data.data.deposit_array;
            this.retirement_items = response.data.data.retirement_array;
            this.stock_items = response.data.data.stocks_array;
            this.mutual_fund_items = response.data.data.mutual_fund_array;
            this.bullion_items = response.data.data.bullion_array;
            this.bonds_items = response.data.data.bonds_array;
            this.realestate_items = response.data.data.realestate_array;
            this.private_investment_items =  response.data.data.private_investment_array;
    })
    },
    details() {
      this.$router.push({ name: 'MemberDetails' }).catch(() => {});
    },
    backButton1() {
      this.$router.push({ name: 'ValueAddedServices' }).catch(() => {});
    },
    backButton2() {
      this.$router.push({ name: 'MyWill' }).catch(() => {});
    },
    editItem(item) {
          this.isHidden = !this.isHidden
    },
  },
};
</script>
<style>
.dialog-para {
  font-size: 14px;
  color: #333333;
  font-style: 'Lato';
}
.disabled {
      pointer-events:none;
}
</style>
